
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'CurrencyInput',
  emits: ['update:model-value'],

  props: {
    currency: {
      type: String,
      default: '€'
    },
    label: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
    modelValue: {
      type: [String, Number]
    },
  },

  setup (props, { emit }) {

    const emitPrice = ($event) => {
      emit('update:model-value', $event)
    }

    return {
      emitPrice
    }
  }
})
